import { Component } from "react";
import PropTypes from "prop-types";
import L from "leaflet";
import moment from "moment";
import { FORMAT_DDMMYYYY } from "../../constantsObservacions";
import { colorsIcones } from "../../constantsObservacions";
/**
 * Si el texte rebut per parametre es null retorna un "-", sino retornar el mateix paràmetre
 * @param {String} text
 * @return {String}
 */
const getText = text => {
  return typeof text !== "undefined" && text !== null ? text : "-";
};

// Mida del circle (icona segons el zoom de visualització
const calculateRadius = zoom => {
  // MAD: modifico el cálcul del circle
  return Math.pow(2, 10 - zoom) * 750;
};

/**
 * Retornar un color segons el valor. Retorna un String, podría retornar un color en qualsevol
 * @param {Number} valorObservacio
 */
const calcularColorSegonsValor = valorObservacio => {
  return colorsIcones[valorObservacio];
};

class VectorLayer extends Component {
  constructor(props) {
    super(props);

    const { active, lMap, lControl, name } = props;
    this.layerGroup = L.layerGroup();
    this.name = name;

    if (active) {
      lMap.addLayer(this.layerGroup);
    }

    //Si no tiene la propiedad lControl no se mostara en la control de capas
    if (lControl) {
      lControl.addOverlay(this.layerGroup, name);
    }

    //Es modifica el radi dels markers segons el nivell de zoom. Si no es posa al fer zoom es veuen els cercles grans
    lMap.on("zoomend", () => {
      var currentZoom = lMap.getZoom();

      const radius = calculateRadius(currentZoom);

      lMap.eachLayer(() => {
        this.layerGroup.eachLayer(layer => {
          //layer.eachLayer(layer => {
          layer.setRadius(radius);
          //});
        });
      });
    });
  }

  pintarDades = () => {
    const { dades, lMap } = this.props;
    if (
      typeof dades === "undefined" ||
      dades === null ||
      !dades ||
      !Array.isArray(dades)
    ) {
      this.layerGroup.clearLayers();
      return;
    }
    this.layerGroup.clearLayers();
    const radius = calculateRadius(lMap.getZoom());

    dades.forEach(observacio => {
      const dataObservacio = getText(
        moment(observacio.dataObservacio).format(FORMAT_DDMMYYYY)
      );
      const nomObservador = `${getText(observacio.nomObservador)} ${getText(
        observacio.cognom1Observador
      )}`;

      const textObservador =
        observacio.nomUsuari +
        (observacio.permisMostrarNom ? " - " + nomObservador : "");

      L.circle([observacio.latitudIndret, observacio.longitudIndret], {
        radius: radius,
        color: calcularColorSegonsValor(observacio.valorObservacio),
        fillColor: calcularColorSegonsValor(observacio.valorObservacio),
        name: "Observacio",
        fillOpacity: 1,
        opacity: 0.8
      })
        .addTo(this.layerGroup)
        .bindPopup(
          `
            <div style="color: #ce3b74;border-bottom: 1px solid #ce3b74;padding-bottom: 6px;font-size: 14px;text-align: center;"><strong>Data: ${dataObservacio}</strong></div>
            <div style="display: grid;grid-template-columns: 77px 1fr;row-gap: 5px;margin-top: 8px;">
            <strong>Observador:</strong><span>${textObservador}</span>
            <strong>Municipi:</strong><span>${observacio.nomMunicipi}</span>
            <strong> Latitud:</strong><span>${observacio.latitudIndret.toFixed(
              5
            )}</span>
            <strong>Longitud:</strong><span>${observacio.longitudIndret.toFixed(
              5
            )}</span>
            <strong>Altura:</strong><span>${observacio.alturaIndret}</span>
            </div>
            `,
          { closeButton: false }
        );
    });
  };

  componentDidMount() {
    this.pintarDades();
  }

  //Afagar les noves dades i pintarles al mapa
  componentDidUpdate() {
    this.pintarDades();
  }

  render() {
    return null;
  }
}

VectorLayer.propTypes = {
  active: PropTypes.bool,
  lMap: PropTypes.object,
  lControl: PropTypes.object,
  name: PropTypes.string,
  dades: PropTypes.array,
  iconFunc: PropTypes.func
};

export default VectorLayer;
